import { SVG, SVGProps } from './svg'

export function IconOhlcChartType(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M11 0h2v6h5v2h-5v16h-2v-6H6v-2h5V0Z" />
    </SVG>
  )
}
